module.exports = __webpack_public_path__ + "media/images/icons/eye-4bfa150643f425e51b1a5ac32909acb1.svg";